import { colorMap, SecondaryColors } from '@/utils/constants';

const resolveBgColor = ({ rawVal }: { rawVal: string }) => {
  if (/^eggshell|light|"eggshell"$/i.test(rawVal)) {
    return colorMap.eggshell;
  }

  if (/^dark-gray|"dark-gray"$/i.test(rawVal)) {
    return colorMap['dark-gray'];
  }

  if (/^charcoal|dark|"charcoal"$/i.test(rawVal)) {
    return colorMap.charcoal;
  }

  if (/^black|"black"$/i.test(rawVal)) {
    return colorMap.black;
  }

  if (/^white|"white"$/i.test(rawVal)) {
    return colorMap.white;
  }

  if (/^medium-gray|"medium-gray"$/i.test(rawVal)) {
    return colorMap['medium-gray'];
  }

  if (/^blue|"blue"$/i.test(rawVal)) {
    return SecondaryColors.main;
  }

  return undefined;
};

export default resolveBgColor;
